import * as yup from 'yup';
import { FORM_KEYS, NO_OF_CHARS } from 'shared/constant';

const { BANK } = FORM_KEYS;

export const bankFieldsSchema = (intl, elementName, isIban) => {
  switch (elementName) {
    case BANK.BANK_NAME:
      return yup.object().shape({
        [BANK.BANK_NAME]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.bankName' }) })),
      });
    case BANK.ACCOUNT_NAME:
      return yup.object().shape({
        [BANK.ACCOUNT_NAME]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.accountName' }) }))
          .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    case BANK.CURRENCY:
      return yup.object().shape({
        [BANK.CURRENCY]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.currency' }) })),
      });
    case BANK.IBAN:
      return yup.object().shape({
        [BANK.IBAN]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: isIban === true ? 'bankDetails.iBan' : 'bankDetails.acctNo' }) }))
          .test(
            intl.formatMessage({ id: 'validation.invalidFormat' }),
            intl.formatMessage({ id: 'validation.invalidFormat' }),
            (value) => {
              if (isIban === true) {
                if (window.IBAN && window.IBAN.isValid(value)) return true;
              }
              if (isIban === false && value) {
                return true;
              }
              return false;
            },
          ),
      });
    default:
      return null;
  }
};

export const otherBankSchema = (intl, bankNameValue) => yup.object().shape({
  [BANK.OTHER_BANK_NAME]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.otherBankName' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.otherBankName' }) }),
      (value) => {
        if (bankNameValue && !value) return false;
        return true;
      },
    )
    .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
    .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
});

export const domicileCountrySchema = (intl, bankNameValue) => yup.object().shape({
  [BANK.DOMICILE_COUNTRY]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.domicileCountry' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.domicileCountry' }) }),
      (value) => {
        if (bankNameValue && !value) return false;
        return true;
      },
    ),
});

/**
 * Whole page or accordion validation
 * @param {*} intl
 */
export const bankDetailPageSchema = (intl, bankNameValue) => yup.object().shape({
  [BANK.BANK_NAME]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.bankName' }) })),
  [BANK.ACCOUNT_NAME]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.accountName' }) }))
    .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.invalidMinNumberOfChars' }))
    .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.invalidMaxNumberOfChars' })),
  [BANK.CURRENCY]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.currency' }) })),
  [BANK.IBAN]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.iBan' }) })),
  [BANK.OTHER_BANK_NAME]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.otherBankName' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.otherBankName' }) }),
      (value) => {
        if (bankNameValue === 'NW-MAR-BANK-OTH' && !value) return false;
        return true;
      },
    ),
  [BANK.DOMICILE_COUNTRY]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.domicileCountry' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'bankDetails.domicileCountry' }) }),
      (value) => {
        if (bankNameValue === 'NW-MAR-BANK-OTH' && !value) return false;
        return true;
      },
    ),
});

// const bankDetailsSchema = {
//   bankFieldsSchema,
//   bankDetailPageSchema,
// };

// export default bankDetailsSchema;
